import { interpolate, interpolateRound } from "d3-interpolate";
import { identity } from "./continuous.js";
import { initInterpolator } from "./init.js";
import { linearish } from "./linear.js";
import { loggish } from "./log.js";
import { symlogish } from "./symlog.js";
import { powish } from "./pow.js";
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function (_) {
        return arguments.length ? (x0 = _[0], x1 = _[1], _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
    };
    scale.clamp = function (_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function (_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function (_) {
            var r0, r1;
            return arguments.length ? (r0 = _[0], r1 = _[1], _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
        };
    }
    scale.range = range(interpolate);
    scale.rangeRound = range(interpolateRound);
    scale.unknown = function (_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function (t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
export function copy(source, target) {
    return target
        .domain(source.domain())
        .interpolator(source.interpolator())
        .clamp(source.clamp())
        .unknown(source.unknown());
}
export default function sequential() {
    var scale = linearish(transformer()(identity));
    scale.copy = function () {
        return copy(scale, sequential());
    };
    return initInterpolator.apply(scale, arguments);
}
export function sequentialLog() {
    var scale = loggish(transformer()).domain([1, 10]);
    scale.copy = function () {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return initInterpolator.apply(scale, arguments);
}
export function sequentialSymlog() {
    var scale = symlogish(transformer());
    scale.copy = function () {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return initInterpolator.apply(scale, arguments);
}
export function sequentialPow() {
    var scale = powish(transformer());
    scale.copy = function () {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return initInterpolator.apply(scale, arguments);
}
export function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}
